export function getCSSVariable(variableName: string): string {
  const root = document.documentElement // Get the root element
  const styles = getComputedStyle(root) // Get the computed styles
  return styles.getPropertyValue(variableName).trim() // Return the value of the CSS variable
}
export const primaryColor = getCSSVariable('--kt-primary')
export const primaryActive = getCSSVariable('--kt-primary-active')
export const whiteColor = getCSSVariable('--kt-primary-light')
export const successColor = getCSSVariable('--kt-success')
export const redColor = '#F64E60'
export const blackColor = '#333'
export const lightGrayColor = '#d3d3d3'
export const BASE_URL = process.env.REACT_APP_SERVER_API_URL
export const userNameLocalStorageKey = 'userName'
export const getUserName = () => {
  const userName = localStorage.getItem(userNameLocalStorageKey) || ''
  if (!userName) return null
  return userName
}

export const setUserName = (userName: string) => {
  if (!userName) return
  localStorage.setItem(userNameLocalStorageKey, userName)
}

export const removeUserFromLocalStorage = () => {
  localStorage.setItem(userNameLocalStorageKey, '')
}
